var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height"},[_c('v-col',{staticClass:"text-h4 white-space-nowrap",attrs:{"cols":"2"}},[_vm._v(" "+_vm._s(_vm.coreCard.value)+" ")]),_c('v-col',{attrs:{"cols":"10"}},[_c('div',[_c('canvas',{ref:"pieChart"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }